<template>
  <template v-if="PAYMENT_TYPE.LIQPAY_MERCHANT === payment.type">
    <form
      method="POST"
      :action="payment.redirectUrl"
      accept-charset="utf-8"
      style="width: 100%"
    >
      <input type="hidden" name="data" :value="payment.data" />
      <input type="hidden" name="signature" :value="payment.signature" />
      <input class="button-primary" type="submit" :value="_T('@Pay for')" />
    </form>
  </template>
  <ButtonPrimary
    v-else-if="PAYMENT_TYPE.MONOBANK_PAYPARTS === payment.type"
    @click.prevent="modalStore.toggleModal(monobankPayPartsModal, { payment })"
  >
    {{ _T("@Pay for") }}
  </ButtonPrimary>
  <NuxtLink v-else class="button-primary" :to="payment.redirectUrl">
    {{ _T("@Pay for") }}
  </NuxtLink>
</template>

<script setup>
import { PAYMENT_TYPE } from "~/utils/paymentFormatter";
import {
  monobankPayPartsModal,
  useModalStore,
} from "~/modules/shared/modals/store/modalStore";
import ButtonPrimary from "~/modules/shared/buttons/ButtonPrimary.vue";

const props = defineProps({
  payment: { type: Object, required: true },
});

const modalStore = useModalStore();
</script>

<style scoped lang="scss"></style>
